import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
import Sanitize from '../../Sanitize';
const GLOBAL = require('../../Globals');

class EnterMarkStud extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			acyear : '',
			cls : '',
			section : '',
			examname : '',
			subject : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts: [],
			accyear : [],
			exams : [],
			subj : [],
			modal : false,
			student : '',
			modal1 : false,
			timetab : [],
			data : [],
			marks : [],
			markdata : [],
			subid : '',
			mark : '',
			remarks : '',
			sections : [],
			sec : [],
			allocateSubject : [],
			allocateClass : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onExChange = this.onExChange.bind(this);
		this.onModChange = this.onModChange.bind(this);
		this.onStudChange = this.onStudChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleRemarkChange = this.handleRemarkChange.bind(this);
		this.onMarkUpdate = this.onMarkUpdate.bind(this);
		this.onReMarkUpdate = this.onReMarkUpdate.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	toggle1(){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getexam();
		
	}
	
	onClassChange(e){
		this.state.cls = e.target.value;
		this.getsection();
	}
	
	/** set value **/
	onExChange(e){
		this.state.examname = e.target.value;
		
	}
	
	/** set value **/
	onModChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** set value **/
	onSecChange(e){
		this.state.section = e.target.value;
		this.getdata();
		this.getsubject();
	}
	
	/** set value **/
	onStudChange(e){
		this.state.student = e.target.value;
		this.getmark();
	}
	
	handleChange(id,e){
		
		this.state.subid = id;
		this.state.mark = e.target.id;
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	handleRemarkChange(id,e){
		
		this.state.subid = id;
		this.state.remarks = e.target.id;
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	onInputChange(id,e){
		
		var index = this.state.marks.findIndex(function(obj){
			
		return (obj.id == id); });
		
		if(index === -1){ 
			this.state.marks.push({"id":id, "mark":e.target.value, "remarks":''});
		}
		else{
			this.state.marks[index].mark = e.target.value;
		}
	}
	
	onRemarkChange(id,e){
		
		var index = this.state.marks.findIndex(function(obj){
		return (obj.id == id); });
		
		if(index != -1){ 
			this.state.marks[index].remarks = e.target.value;
		}
	}
	
	onClick(e){
		document.getElementById("examform").reset();
	}
	
	onMarkUpdate(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('exam/editexammarksbystud',this.state).then((result) => {
			this.toggle();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.getmark();
			}
			else{
				this.toggle();
				this.getmark();
			}
			$("#showLoader").hide();
		});	
	}
	
	onReMarkUpdate(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('exam/editremarksbystudent',this.state).then((result) => {
			 this.toggle1();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.getmark();
			}
			else{
				this.toggle1();
				this.getmark();
			}
			 $("#showLoader").hide();
		});	
	}
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		this.state.maxmark = $("#mmark").val();
		var qdata = { acyear: this.state.acyear, cls : this.state.cls, section : this.state.section, examname : this.state.examname, student : this.state.student, marks : this.state.marks, maxmark : this.state.maxmark };
		PostData('exam/saveexammarksbystudent',{ sdata: qdata }).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				alert('Marks Added Successfully!..');
				this.setState({marks : []});
				this.getmark();
				//document.getElementById("markform").reset();
			}
			else{
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});	
	}
	
	onUpdate(){
		 $("#showLoader").show();
		PostData('examcbse/editpassmark',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			// console.log(responseJson);
			if(responseJson.status == '1' ){
				// console.log(JSON.stringify(responseJson));
				this.toggle();
				this.setState({
					_message:'Time Table Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				this.setState({subject : '',passmark : ''});
				this.getdata();
			}
			else{
				this.toggle();
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});	
		
	}
	
	componentWillMount() {
		 
		this.getacyear();
		this.getclass();
	}
	
		/** get Academic Year **/
	getacyear(){
		 $("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				if(userData['userrole'] == 'markentry'){
					this.checkstaff();
				}
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
			}
			this.getallocatesection();
			this.getexam();
		});
	}
	
	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}
	
	checkstaff(){
		$("#showLoader").show();
		GetData('employee/checkstaff/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson.status==1){
				this.setState({
					allocateSubject : responseJson.data,
					allocateClass : responseJson.class,
				});
			}
			$("#showLoader").hide();
		});
	}
	
	//get allocate section details
	getallocatesection(){

		GetData('section/getsecbyacyear/'+this.state.acyear).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					sections : responseJson
				});
			}
		});
	}
	
	getclass(){
		 $("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	// Get Section By Class
	getsection(){
		var dat = [];
		if(this.state.cls!=''){
			for(var i=0;i<this.state.sections.length;i++)	{

				if(this.state.sections[i].clas == this.state.cls){
					dat.push(this.state.sections[i]);
				}
			}
		}
		this.setState({sec : dat});
	}
	
	getexam(){
		
		var ac = $("#year").val();
		 $("#showLoader").show();
		GetData('exam/getexambyacyear/'+ac).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					exams : responseJson
				});
			}
		});
	}
	
	getsubject(){
		
		$("#showLoader").show();
		//GetData('exam/getsubjectbyclasswithexamdetails/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.examname).then((result) => {
		GetData('assignsubject/getsubbyclsdim/'+this.state.acyear+'/'+this.state.cls).then((result) => {
			 
			let responseJson = result;
			if(responseJson){
				this.setState({
					subj : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}
	
	getdata(){
		
		$("#showLoader").show();
		GetData('student/getstddetailsbymsg/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.section).then((result) => {
			 
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}
	
	getmark(){
		
		 $("#showLoader").show();
		GetData('exam/getmarksbystudent/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.section+'/'+this.state.examname+'/'+this.state.student).then((result) => {
			
			let responseJson = result;
			if(responseJson){
				this.setState({
					markdata : responseJson
				});
			}
			 $("#showLoader").hide();
		});
	}
	
	getmarkbystud(subject){
		
		var dat = [];
		
		if(this.checkmarks(subject)!=false){
			
			dat.push(<td><Button size="sm" color={this.checkmarks(subject) == 'AB' ? "danger" : "primary"} id={this.checkmarks(subject)} onClick={this.handleChange.bind(this,subject)}>{this.checkmarks(subject)}</Button></td>);
		}
		else{
			
			dat.push(<td>
				<input type="text" className="checkmaxval" list="absent" onKeyPress={Sanitize.integerKeyPress} onChange={this.onInputChange.bind(this,subject)} />
				<datalist id="absent">
					<option value="AB"></option>
				</datalist>
			</td>);
		}
		
		return dat;
	}
	
	checkmarks(subject){
		
		var bstate = false;
		
		for(var i=0; i<this.state.markdata.length; i++){
			
			if(this.state.markdata[i].subject == subject){
				
				bstate = parseFloat(this.state.markdata[i].mark) == '-1' ? 'AB' : parseFloat(this.state.markdata[i].mark);
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getremark(subject){
		
		var dat1 = [];
		
		if(this.checkremarks(subject)=== false){
			
			dat1.push(<td><input type="text" onChange={this.onRemarkChange.bind(this,subject)} /></td>);
		}
		else{
			
			dat1.push(<td><Button size="sm" color="primary" onClick={this.handleRemarkChange.bind(this,subject)}>{this.checkremarks(subject)}</Button></td>);
			
		}
		
		return dat1;
	}
	
	checkremarks(subject){
		
		var boolstate = false;
		
		for(var j=0; j<this.state.markdata.length; j++){
			
			if(this.state.markdata[j].subject == subject){
				
				boolstate = this.state.markdata[j].remarks;
				break;
			}
			else{
				
				boolstate = false;
			}
		}
		
		return boolstate;
	}
	
	checkSub(sub){
		var bstate = false;
		var d = this.state.allocateSubject;
		var index = d.findIndex(function(obj){
			return(obj.subject == sub);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		if(this.state.userRole == 'classteacher'){
			var index = d.findIndex(function(obj){
				return(obj.class == cls);
			});
			if(index > -1){
				bstate = true;
			}
		}
		else if(this.state.userRole == 'markentry'){
			if(d.length > 0){
				var dat = d[0]['classes'].split(',');
				var index = dat.findIndex(function(obj){
					return(obj == cls);
				});
				if(index > -1){
					bstate = true;
				}
			}
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
	var exa = this.state.exams;
	var items = this.state.posts;
	var acyear = this.state.accyear;
	var secs = this.state.sec;
	var std = this.state.data;
	
	if(this.state.acyear!='' && this.state.cls!='' && this.state.section!='' && this.state.student!='' && this.state.examname!=''){
		
		$("#markenter").show();
	}
	else{
		
		$("#markenter").hide();
	}
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="markform" encType="multipart/form-data" onSubmit={this.onSubmit} >
			  <input type="hidden" name="maxmark" id="mmark" value="100" />
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Enter Marks By Student</strong><span style={{float : 'right'}}><span id="maxmark"></span></span>
							<Row style={{margintop : '10px'}}>
								<Col md={2} sm={12} xs={12}>
									<label>Academic Year</label>
									<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
										<option value="">Select Academic Year</option>
										{
											acyear.map(function (item) {
												return <option value={item.id }>{item.value}</option>;
											})
										}
									</select>
								</Col>
								<Col md={3} sm={12} xs={12}>
									<label>Exam</label>
									<select name="examname" onChange={this.onExChange} className="form-control" required id="exam">
										<option value="">Select Exam</option>
										{
											exa.map(function (item) {
												return <option value={item.id }>{item.exam}</option>;
											})
										}
									</select>
								</Col>
								<Col md={2} sm={12} xs={12}>
									<label>Class</label>
									<select name="cls" onChange={this.onClassChange} className="form-control" required id="clas">
										<option value="">Select Class</option>
										{(this.state.userRole == 'classteacher' || this.state.userRole == 'markentry') ?
											items.map((item)=>{
												if(this.checkClass(item.id)){
													return <option value={item.id}>{item.class}</option>;
												}
											})
											:
											items.map(function (item) {
												return <option value={item.id}>{item.class}</option>;
											})
										}
									</select>
								</Col>
								<Col md={2} sm={12} xs={12}>
									<label>Section</label>
									<select name="section" onChange={this.onSecChange} className="form-control" required id="secs">
										<option value="">Select Section</option>
										{(this.state.userRole == 'classteacher') ?
											secs.map((item)=>{
												if(this.checkSection(item.section)){
													return <option value={item.section}>{item.secs}</option>;
												}
											})
											:
											secs.map(function (item) {
												return <option value={item.section}>{item.secs}</option>;
											})
										}
									</select>
								</Col>
								<Col md={3} sm={12} xs={12}>
									<label>Student</label>
									<select name="student" onChange={this.onStudChange} className="form-control" required id="stud">
										<option value="">Select Student</option>
										{
											std.map(function (item) {
												return <option value={item.regno}>{item.stdname}</option>;
											})
										}
									</select>
								</Col>
								<Col md={12} sm={12} xs={12}>
									<span className="btn-right text-danger">Note : (Check Exam Time Table Created for Student Class)</span>
								</Col>
							</Row>
							
						</CardHeader>
						<CardBody>
							<Row id="markenter">
							  <Col md="12">
								<Table responsive bordered>
									<thead>
										<tr>
											<th>S.No</th>
											<th>Subject Name</th>
											<th>Mark</th>
											<th>Remarks</th>
											<th>Maxmark</th>
										</tr>
									</thead>
									<tbody>
										{this.state.userRole == 'markentry' ?
											this.state.subj.map((item,index) =>{
												if(this.checkSub(item.subject)){
												return(<tr key = {item}>
													<td>{index+1}</td>
													<td>{item.sub}</td>
													{this.getmarkbystud(item.subject)}
													{this.getremark(item.subject)}
													<td>100</td>
												</tr>)
											}})
										:	this.state.subj.map((item,index) =>
							 
											<tr key = {item}>
												<td>{index+1}</td>
												<td>{item.sub}</td>
												{this.getmarkbystud(item.subject)}
												{this.getremark(item.subject)}
												<td>100</td>
											</tr>
										)}
									</tbody>
								</Table>
								<Modal isOpen={this.state.modal} toggle={this.toggle} className={'modal-sm ' + this.props.className}>
								  <ModalHeader toggle={this.toggle}>Edit Mark</ModalHeader>
								  <ModalBody>
									<Row>
									  <Col md="12">
									   <FormGroup>
										<Label htmlFor="name">Mark <span className="text-danger">*</span></Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<input type="number" name="mark" min="0" max={this.state.mval} required value={this.state.mark} onChange={this.onModChange} />
									   </FormGroup>
									  </Col>
									</Row>
								  </ModalBody>
								  <ModalFooter>
									<Button type="submit" color="primary" onClick={this.onMarkUpdate}>Submit</Button>
									<Button color="secondary" onClick={this.toggle}>Cancel</Button>
								  </ModalFooter>
							  </Modal>
							  <Modal isOpen={this.state.modal1} toggle={this.toggle1} className={'modal-sm ' + this.props.className}>
								  <ModalHeader toggle={this.toggle1}>Edit Remarks</ModalHeader>
								  <ModalBody>
									<Row>
									  <Col md="12">
									   <FormGroup>
										<Label htmlFor="name">remark <span className="text-danger">*</span></Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<input type="text" name="remarks" value={this.state.remarks} onChange={this.onModChange} />
									   </FormGroup>
									  </Col>
									</Row>
								  </ModalBody>
								  <ModalFooter>
									<Button type="submit" color="primary" onClick={this.onReMarkUpdate}>Submit</Button>
									<Button color="secondary" onClick={this.toggle1}>Cancel</Button>
								  </ModalFooter>
							  </Modal>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default EnterMarkStud;


// WEBPACK FOOTER //
// ./src/exams/Mark/EnterMarkStud.js